import { createContext, useContext } from 'react';

// Shared live data for everything inside the Academy Portal shell — the
// signed-in player's own record, their groups, their conversations and the
// academy doc. AcademyPortalDataProvider (components/academy) subscribes to
// each ONCE; useMyPlayer/useGroups/useConversations/useAcademy read from
// here when mounted under it, and only fall back to their own listener when
// used outside the shell (e.g. admin pages). Before this, every page and
// sub-component opened its own copies (useFeed and useAcademyEvents each
// opened useMyPlayer + useGroups again internally), so Home alone ran
// ~15 listeners that all had to resolve before anything settled.
export const AcademyPortalDataContext = createContext(null);

export function useAcademyPortalData() {
  return useContext(AcademyPortalDataContext);
}
